































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Product } from '@/models'

@Component({
  components: {
    ElementTracingRow: () => import('@/components/tracing/ElementTracingRow.vue')
  }
})
export default class ProductTracingCard extends Vue {
  @Prop({ required: true, type: Object }) readonly product: Product
}
